import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-svgo_sort-desc",
  "use": "icon-svgo_sort-desc-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-svgo_sort-desc\"><path fill-opacity=\"0\" d=\"M-1.982 17h17.733V0H-1.982z\" /><path stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" d=\"M10.749 1.981v12.59m0 0l3.718-3.951M1 8.96h6.121M1 4.625h6.121M1 13.355h6.121\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol